module.exports = __webpack_public_path__ + "static/img/best_costume_design_block_5.6d9af0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_costume_design_block_5.jpg
// module id = 240
// module chunks = 0